import { TableCompData } from "../../../../components";
import EmptyTable from "../../../../components/Common/EmptyTable";
import { SettingFineSettingHeader } from "../../../../utils/TableHeader";
import { useGetFinesQuery, useGetFineCategoriesQuery, useToggleFineStatusMutation } from "../../../../store/admin/settings/fineSlice";
import { useMemo } from "react";
import { toast } from "react-hot-toast";

export default function FineSettingComp({
  TableDropDown,
  onSubmit,
  emptyTable,
}) {
  const { data: fines, isLoading: isLoadingFines } = useGetFinesQuery();
  const { data: categories, isLoading: isLoadingCategories } = useGetFineCategoriesQuery();
  const [toggleStatus] = useToggleFineStatusMutation();

  const handleToggle = async (row) => {
    if (row.isNew) {
      toast.error("Please configure the fine first");
      return;
    }
    try {
      const res = await toggleStatus(row.id).unwrap();
      if (res.status) {
        toast.success(res.message);
      }
    } catch (err) {
      toast.error(err?.data?.message || "Failed to update status");
    }
  };

  // Merge categories and fines to ensure every category is shown
  const mergedData = useMemo(() => {
    if (!categories) return [];
    
    // Convert fines list to a map for easy lookup by category_id
    const finesMap = {};
    const extractFines = (f) => {
      if (!f) return;
      
      // Handle the nested structure: response.data.company_fines
      let list = [];
      if (Array.isArray(f)) {
        list = f;
      } else if (Array.isArray(f?.company_fines)) {
        list = f.company_fines;
      } else if (f?.data && Array.isArray(f.data)) {
        list = f.data;
      } else if (f?.data?.company_fines && Array.isArray(f.data.company_fines)) {
        list = f.data.company_fines;
      }

      list.forEach(fine => {
        // Use string keys to avoid type mismatch issues (int vs string)
        finesMap[String(fine.fine_category_id)] = fine;
      });
    };
    
    extractFines(fines);

    return categories.map(category => {
      const existingFine = finesMap[String(category.id)];
      return {
        id: existingFine?.id, // if exists
        fine_category_id: category.id,
        category_name: category.name,
        name: existingFine?.name || `${category.name} Fee`,
        amount: existingFine?.amount || 0,
        is_active: existingFine ? existingFine.is_active : 0,
        date_added: existingFine?.created_at, // Map the creation date
        status: existingFine ? (existingFine.is_active ? "Active" : "Disabled") : "Not Set",
        // for internal use in actions
        isNew: !existingFine,
        onToggle: handleToggle
      };
    });
  }, [fines, categories, handleToggle]);

  return (
    <div className="fine-settings-table">
      <style>
        {`
          .fine-settings-table .rdt_TableBody::-webkit-scrollbar,
          .fine-settings-table .rdt_Table::-webkit-scrollbar {
            display: none;
          }
          .fine-settings-table .rdt_TableBody,
          .fine-settings-table .rdt_Table {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}
      </style>
      <div className="mb-5">
        <TableCompData
          marginBottom={"0"}
          columns={SettingFineSettingHeader(TableDropDown)}
          data={mergedData}
          progressPending={isLoadingFines || isLoadingCategories}
          message={
            <EmptyTable
              Message={emptyTable || "No fine categories available"}
              btnText={"Configure fines"}
              onClick={onSubmit}
            />
          }
        />
      </div>
    </div>
  );
}
